import { render, staticRenderFns } from "./taxesInfo.vue?vue&type=template&id=491dfe48"
import script from "./taxesInfo.vue?vue&type=script&lang=js"
export * from "./taxesInfo.vue?vue&type=script&lang=js"
import style0 from "./taxesInfo.vue?vue&type=style&index=0&id=491dfe48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports